import * as Actions from '../actions/loadStateMailing.actions'

const initialState = {
  stateMailingList: [],
}

export default function (state = initialState, action) {
  const newState = { ...state }
  switch (action.type) {
    case Actions.GET_STATE_MAILING_SUCCESS: {
      return {
        ...newState,
        stateMailingList: [...action.data],
      }
    }
    default: {
      return newState
    }
  }
}
